<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar
        color="transparent"
        class="elevation-0 pa-0 page-header-toolbar"
      >
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />

        <action-button
          type="delete"
          @click="del(permission.id)"
          v-if="permission.id && $can('permission-delete')"
        />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="permission.name"
                  v-model="permission.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('permissions.name')"
                  :error-messages="errors.collect('permission.name')"
                  autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="permission.module"
                  v-model="permission.module"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="$dd_modules()"
                  :menu-props="permission.module"
                  :label="$t('permissions.module')"
                  :error-messages="errors.collect('permission.module')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { ActionButton } from "@brakomp/ui"

export default {
  components: { ActionButton },
  name: "PermissionForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      predata: {},
      permission: {},
      dictionary: {
        attributes: {
          "permission.name": this.$t("permissions.name"),
          "permission.module": this.$t("permissions.module"),
        },
      },
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(
        next,
        this.permission,
        this.predata,
        this.save,
        this.isFormValid,
      )
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid)
    },
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("permissions.new_permission")
      this.permission = {}

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.permission))
    } else {
      this.title = this.$t("permissions.update_title")

      axios
        .get(this.API_URL + "permission/" + this.id)
        .then(res => {
          this.permission = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.permission))

          this.page_title = this.$t("permissions.edit_permission", {
            name: this.permission.name,
          })
        })
        .catch(err => console.log(err))
    }
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.permission.id) {
              // Create
              axios
                .post(this.API_URL + "permission", {
                  name: this.permission.name,
                  module: this.permission.module,
                })
                .then(res => {
                  if (res.data.data.id) {
                    vm.permission = res.data.data
                    vm.predata = JSON.parse(JSON.stringify(vm.permission))

                    vm.page_title = vm.$t("permissions.edit_permission", {
                      name: vm.permission.name,
                    })
                    vm.$awn.success(vm.$t("global.create_success"))
                    vm.$router
                      .replace(
                        this.BACKEND_URL +
                          `/permissions/edit/${vm.permission.id}`,
                      )
                      .catch(() => {})
                  }
                })
                .catch(err => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "permission", {
                  id: this.permission.id,
                  name: this.permission.name,
                  module: this.permission.module,
                })
                .then(res => {
                  vm.permission = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.permission))

                  vm.page_title = vm.$t("permissions.edit_permission", {
                    name: vm.permission.name,
                  })

                  vm.$store.dispatch("auth/updateUserState", vm)
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch(err => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "permission/" + id)
            .then(() => {
              vm.$store.dispatch("auth/updateUserState", vm)
              vm.$router.push(this.BACKEND_URL + "/permissions")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch(err => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no"),
          },
        },
      )
    },
  },
}
</script>

<style scoped></style>
